/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_As_User_RefusedInputs */



/**
* | output |
* | --- |
* | "Cruitive can't be viewed as that user, who may have left or not logged in yet. You're back as yourself, and what you just did wasn't saved." |
*
* @param {View_As_User_RefusedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const view_as_user_refused = /** @type {((inputs?: View_As_User_RefusedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_As_User_RefusedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Cruitive can't be viewed as that user, who may have left or not logged in yet. You're back as yourself, and what you just did wasn't saved.")
	return /** @type {LocalizedString} */ ("Det går inte att visa Cruitive som användaren, som kan ha slutat eller inte ha loggat in än. Du är tillbaka som dig själv, och det du gjorde nyss sparades inte.")
});